module.exports = __webpack_public_path__ + "img/icon-ai-light-purple.126f45cf.svg";